<template>
  <div
    class="container-fluid container-page-title-image"
    :style="style"
  >
    <div class="row">
      <div class="col-md-12 text-center py-5">
        <h1 class="text-page-title bg-dark-trans text-white p-3">
          <img
            class="mt-n2"
            src="/img/logo/logo.png"
            alt="Logo"
            width="auto"
            height="40"
          >
          {{ title }}
        </h1>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: String,
    image: String,
    extraStyles: Object,
  },
  computed: {
    style () {
      return {...{backgroundImage: 'url(' + this.image + ')'}, ...this.extraStyles};
    }
  }
}
</script>
